import { useEffect, useState } from 'react';
import React from 'react'
import { ITopTen, ITopTenTeacher, ITypeForTopTen } from '../../../types';
import { getOverAllDistrictAndBlockTopTotalUsagesStudent, getOverAllDistrictTopTotalUsagesStudent, getOverAllTopTotalUsagesStudent, getTeacherTopTen } from '../../../Services/NewStats/StateOverViewAPIs';
import { useSelector } from 'react-redux';
import { State } from '../../../Reducers/types';

export function useTopTen() {

  const { filter } = useSelector((state: State) => state);

  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [data, setData] = useState<ITopTen>();
  const [teacherData, setTeacherData] = useState<ITopTenTeacher[]>();
  const [isFirst, setIsFirst] = useState<boolean>(true);
  const [paramsValue, setParamsValue] = useState();


  const getTopTenData = async (district: string, block: string, type: ITypeForTopTen, week_no: number) => {
    try {
      setIsLoading(true);
      if (type?.for == "student") {
        if (district === "all") {
          const res = await getOverAllTopTotalUsagesStudent(type?.type, week_no, filter.year);
          if (res?.data?.Is_Success) {
            setData(res?.data?.response);
          }

          setIsLoading(false)
        }

        if (district !== "all" && block === "all") {
          const res = await getOverAllDistrictTopTotalUsagesStudent(
            type?.type,
            district,
            week_no,
            filter.year
          );
          if (res?.data?.Is_Success) {
            setData(res?.data?.response);
          }
          setIsLoading(false);
        }

        if (district !== "all" && block !== "all") {
          const res = await getOverAllDistrictAndBlockTopTotalUsagesStudent(
            type?.type,
            district,
            block,
            week_no,
            filter.year
          );
          if (res?.data?.Is_Success) {
            setData(res?.data?.response);
          }
          setIsLoading(false);
        }
      }
      if (type?.for === "teacher") {
        const res = await getTeacherTopTen(
          type?.type,
          district == "all" ? "-1" : district,
          block == "all" ? "-1" : block,
          week_no,
          filter.year
        );
        if (res?.data?.Is_Success) {
          setTeacherData(res?.data?.response);
        }
        setIsLoading(false);
      }
    }
    catch {
      setIsLoading(false);
    }
    setIsLoading(false)
  };

  // const setDataOnParams = () => {
  //   path?.name == "overall";
  //   ? setData(weeklyAvgStudentUsage)
  //   : path?.name == "lt1hrs"
  //   ? setData(weeklyAvgStudentUsagelt1hrs)
  //   : path?.name == "lt2hrs"
  //   ? setData(weeklyAvgStudentUsagelt2hrs)
  //   : console.log("");
  // };
  // const headers = [
  //   { label: "Employ Id", key: "employId" },
  //   { label: "Name", key: "name" },
  //   { label: "School Name", key: "schoolName" },
  //   { label: "School Code", key: "schoolCode" },
  //   { label: "District", key: "district" },
  // ];
  return (
    {
      isLoading,
      setIsLoading,
      isFirst,
      setIsFirst,
      setParamsValue,
      getTopTenData,
      data,
      teacherData,
    }
  )
}
